export const INSTRUCTOR_FILTER_GROUPS = [
  {
    id: "instructor",
    label: "Instructor",
    filters: [
      {
        id: "skills",
        label: "Skills",
        type: "checkbox",
        options: [],
      },
      {
        id: "status",
        label: "Status",
        type: "checkbox",
        options: [
          { value: "active", label: "Active" },
          { value: "archived", label: "Archived" },
        ],
      },
    ],
  },
];
